import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
	CreateNewUserPayloadInterface,
	CreatePasswordPayloadInterface,
	UpdateUserAccessPayloadInterface,
	UserListingInterface,
	UserProfileInterface,
    GetSelectionForDealerRepCreationInterface
} from "../interface/user.interface";
import { Observable, shareReplay } from "rxjs";
import {
	CommonSelectionInterface,
	ListingPayloadInterface,
} from "../interface/common.interface";

@Injectable({
	providedIn: "root",
})
export class UserDataService {
	private basePath: string = `${environment.url}/api/DealerRep/`;
	private basePathAccessRole: string = `${environment.url}/api/DealerRepAccessRole/`;

	constructor(private http: HttpClient) {}

	private getHeaders(): HttpHeaders {
		const defaultHeaders: any = {
			"Content-Type": "application/json",
			responseType: "text",
		};

		return new HttpHeaders(defaultHeaders);
	}

	login(email: string, password: string) {
		const encoded_pass = encodeURIComponent(password);
		return this.http.post(
			`${this.basePath}Login`,
			{ email, password: encoded_pass },
			{ responseType: "text" },
		);
	}

	sendForgotPasswordEmail(objRequest: any, options?: any): Observable<any> {
		let headers = this.getHeaders();
		headers = headers.append("partnerCode", options);

		return this.http.post(
			`${this.basePath}SendForgotPasswordEmail`,
			objRequest,
			{ headers },
		);
	}

	resetPassword(objRequest: any): Observable<any> {
		const headers = this.getHeaders();
		return this.http.post(`${this.basePath}ResetPassword`, objRequest, {
			headers,
		});
	}

	resetPasswordLinkVerify(key: any): Observable<any> {
		return this.http.get(
			this.basePath + "ResetPasswordVerify" + "?key=" + key,
			key,
		);
	}

	getProfile() {
		return this.http.get<UserProfileInterface>(`${this.basePath}GetById`);
	}

	updatePassword(values: {
		oldPassword: string;
		newPassword: string;
		confirmNewPassword: string;
	}) {
		return this.http.post(`${this.basePath}UpdatePassword`, values);
	}

	createPassword(values: CreatePasswordPayloadInterface) {
		let headers = this.getHeaders();

		return this.http.post(`${this.basePath}CreatePassword`, values, {
			headers,
		});
	}

	createPasswordLinkVerify(key: any): Observable<any> {
		return this.http.get(
			this.basePath + "CreatePasswordVerify" + "?key=" + key,
		);
	}

	createNewUser(
		values:
			| CreateNewUserPayloadInterface
			| Partial<CreateNewUserPayloadInterface>,
	) {
		return this.http.post(this.basePath + "Create", values);
	}

	updateUserAccess(id: string, values: Partial<UpdateUserAccessPayloadInterface> | UpdateUserAccessPayloadInterface) {
		return this.http.post(`${this.basePath}Update/${id}`, values);
	}

	deactivateUser(id: string, language: string, partnerCode?: string) {
		let headers = this.getHeaders();
		headers = headers.append("partnerCode", partnerCode);
		return this.http.post(
			`${this.basePath}Deactivate/${id}`,
			{
				language,
			},
			{ headers },
		);
	}

	activateUser(id: string) {
		return this.http.post(`${this.basePath}Activate/${id}`, {});
	}

	getAccessRole() {
		return this.http.get<CommonSelectionInterface[]>(
			this.basePathAccessRole + "GetDealerRepAccessRoleSelection",
		);
	}

	getUserRole() {
		return this.http.get<CommonSelectionInterface[]>(
			this.basePathAccessRole + "GetDealerRepAccessRoleSelection",
		);
	}

	getListing(values: ListingPayloadInterface) {
		return this.http.post<UserListingInterface>(
			this.basePath + "GetListing",
			values,
		);
	}

	getSelectionForDealerRepCreation() {
		return this.http.get<GetSelectionForDealerRepCreationInterface[]>(
			`${this.basePathAccessRole}GetSelectionForDealerRepCreation`,
		);
	}

	getSelectionForDealerRepUpdate(id: string) {
		return this.http.get(
			`${this.basePathAccessRole}GetSelectionForDealerRepUpdate/${id}`,
		);
	}
}
